import { resourceExplorerDataSelector } from "./resourceExplorerDataSelector";
import { RootState } from "../../../../store";

export const resourceExplorerShowBudgetLineSelector = (state: RootState) => {
  const data = resourceExplorerDataSelector(state);

  return data?.show_budget_line;
};
